import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { DIALOG_DATA } from '../../../../global.variable';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-image-capture',
  templateUrl: './image-capture.component.html',
  styleUrl: './image-capture.component.scss',
  standalone: false,
})
export class ImageCaptureComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;

  templateName: string = 'selfieCamera';

  constructor(
    protected camDialogRef: DialogRef,
    private toasterService: ToasterService,
    @Inject(DIALOG_DATA) public dialogData: any,
    private spinnerService: LoadingSpinnerService,
  ) {}
  ngOnInit(): void {
    this.templateName = this.dialogData?.templateName || this.templateName;
  }
  sleep(ms = 250) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  isNightTime(date: Date = new Date()): boolean {
    const hour = date.getHours();
    return hour >= 18 || hour < 6;
  }

  async ngAfterViewInit() {
    this.templateName = this.dialogData?.templateName || this.templateName;
    await this.sleep();

    switch (this.templateName) {
      case 'selfieCamera':
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'user' },
          });
          // night time show white background
          if (this.isNightTime()) {
            var ele: any = document.querySelector('.overlay-backdrop');
            ele.style.backgroundColor = '#FFFFFF';
          }
          this.videoRef.nativeElement.srcObject = stream;
        } catch (err: any) {
          let errorMessage = 'An unknown error occurred. Try again';
          let response = 0;

          if (err.name === 'NotAllowedError') {
            errorMessage =
              'Camera permission denied. Please allow camera access.';
          } else if (err.name === 'NotFoundError') {
            response = 1;
            errorMessage =
              'No camera found. Please ensure your device has a camera.';
          } else if (err.name === 'NotReadableError') {
            errorMessage = 'Camera is already in use by another process.';
          } else if (err.name === 'OverconstrainedError') {
            errorMessage =
              'The requested media device constraints cannot be satisfied.';
          } else if (err.name === 'NotSupportedError') {
            response = 1;
            errorMessage = 'Your browser does not support camera access.';
          }

          this.closeDailogBox(response);
          this.toasterService.setMessage({
            errorMessage: errorMessage,
            successMessage: '',
          });
          throw err;
        }
    }
  }

  ngOnDestroy(): void {
    var ele: any = document.querySelector('.overlay-backdrop');
    if (ele) ele.style.backgroundColor = null;
    this.closeCamera(false);
  }
  closeDailogBox(value: any) {
    this.camDialogRef.close(value);
  }
  capture(): void {
    this.spinnerService.show();
    this.toasterService.notifyUser();
    const video = this.videoRef.nativeElement;
    const canvas = this.canvasRef.nativeElement;
    const context = canvas.getContext('2d');

    if (context) {
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;

      canvas.width = videoWidth;
      canvas.height = videoHeight;

      context.drawImage(video, 0, 0, videoWidth, videoHeight);
      canvas.toBlob((blob: any) => {
        if (blob) {
          const file = new File([blob], 'selfie.avif', { type: 'image/avif' });

          this.closeDailogBox(file);
        } else {
          this.toasterService.setMessage({
            errorMessage: 'Something went wrong. Try Again',
            successMessage: '',
          });
        }
      }, 'image/avif');
    }
  }
  closeCamera(close = true): void {
    if (this.videoRef) {
      const stream = this.videoRef.nativeElement.srcObject as MediaStream;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      this.videoRef.nativeElement.srcObject = null;
    }
    if (close) this.camDialogRef.close();
  }
}
